'use strict';
const _ = require('lodash');
const Backbone = require('backbone');
const template = require('../templates/modal.ejs');

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-modal',
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render');
    },
    /**
     *
     */
    render: function () {
        this.$el.html(template());
        this.$('.modal-content').append((_.isObject(this.model.view) ? this.model.view.render().$el : this.model.view));
        if(!("ontouchstart" in document.documentElement) || !("ontouchstart" in window)) this.$el.addClass('no-touch');
        return this;
    }
});


// WEBPACK FOOTER //
// ./app/scripts/views/modal.js